export const combineCulturalFitDimensions = ({
  score_coopcomp_dimension,
  score_orderchaos_dimension
}) => {
  const array1 = score_coopcomp_dimension.spaces_with_dimension_score.map(
    ({ identification, score_value }) => ({
      label: identification,
      coopcomp: score_value
    })
  )

  const array2 = score_orderchaos_dimension.spaces_with_dimension_score.map(
    ({ identification, score_value }) => ({
      label: identification,
      orderchaos: score_value
    })
  )

  const combinedArray = array1.map((item, index) => {
    return { ...item, ...array2[index] }
  })

  return combinedArray.map(({ label, coopcomp, orderchaos }) => ({
    label,
    culturalFit: { coopcomp, orderchaos }
  }))
}
